<template>
  <div class="scroll">    
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg4>  
          <v-card>
            <v-img height="270" src="@/app/assets/cover.jpg">
              <v-btn fab small absolute class="ma-3" @click="$router.push({path:'/'})"><v-icon>arrow_back</v-icon></v-btn>
              <v-btn @click="toggleShow" :loading="loading" fab small indeterminate dark color="info" style="position:absolute; right:10px; top:10px">
                <v-icon dark>camera_alt</v-icon>
              </v-btn>                  
              <v-layout column align-center justify-center >
                <v-progress-circular
                  v-if="loading"
                  :size="200"
                  :width="15"
                  color="info"
                  indeterminate
                  class="mt-4"
                ></v-progress-circular>            
                <v-avatar v-if="!loading" size="200" class="mt-4" :color="randomColor()">              
                  <img v-if="user && user.originalFileBase64" :src="user.originalFileBase64" >
                  <span v-else class="white--text display-4">{{firstLetter(user ? user.username:null)}}</span>  
                </v-avatar>            
                <h1 class="white--text">{{user ? user.username:null}}</h1>                        
              </v-layout>                                               
            </v-img>            
            <v-card-text class="pa-0">                     
              <v-tabs v-model="selectedTab">
                <v-tab>
                  Profile
                </v-tab>                                                    
              </v-tabs>          
              <v-divider/>
              <v-tabs-items v-model="selectedTab">
                <v-tab-item>
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>Fullname</v-list-item-subtitle>
                      <v-list-item-title>{{ user.name }}</v-list-item-title>                      
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn :to="{name:'profile/form'}" small color="green" fab dark><v-icon>edit</v-icon></v-btn>                                                                         
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider />
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>Email</v-list-item-subtitle>
                      <v-list-item-title>{{ user.email }}</v-list-item-title>                      
                    </v-list-item-content>
                  </v-list-item>                  
                  <v-divider />
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>Phone</v-list-item-subtitle>
                      <v-list-item-title>{{ user.phone }}</v-list-item-title>                      
                    </v-list-item-content>
                  </v-list-item>                  
                  <v-divider />                                    
                </v-tab-item>
              </v-tabs-items>    
            </v-card-text>
          </v-card>         
          <my-upload style="width:100%" field="img"
            @crop-success="cropSuccess"        
              :width="300"
              :height="300"         
              lang-type="en"
              :value.sync="show"
              v-model="show"                
              img-format="png">            
          </my-upload>      
        </v-flex>           
      </v-layout>
    </v-container>    
  </div>  
</template>

<script>
import colors   from 'vuetify/es5/util/colors';
import myUpload from 'vue-image-crop-upload';
import Model    from '@/app/models/Admin';
let model = new Model();


var _ = require('lodash');


export default {
  components: {     
    'my-upload': myUpload    
  },
  data () {
    return {   
      user : {}, 
      user_id: null,
      selectedTab: 0,
      loading: false,
      show: false,            
      imgDataUrl: '', // the datebase64 url of created image      
    };
  },    
  mounted(){
    this.init();
  },
  methods: {
    init(){
      this.loading = true;      
      return model.profileIndex({expand:'originalFileBase64'}).then(data=>{        
        this.user    = data;
        this.user_id = this.user.id;
        this.loading = false;            
      });
    },
    
    randomColor(){
      var randomArray   = colors;
      var color = _.sample(randomArray);     
      return color.base === undefined ? 'info':color.base;
    },

    firstLetter (name) {
      return name? name.charAt(0): null;
    },    

    toggleShow() {
        this.show = !this.show;
    },     

    cropSuccess(imgDataUrl, field){
        //console.log('-------- crop success --------');
        this.imgDataUrl = imgDataUrl;
        
        var block = imgDataUrl.split(";");
        var contentType = block[0].split(":")[1];// In this case "image/gif"
        var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
        var blob = this.b64toBlob(realData, contentType);

        var FormData = require('form-data');
        let formData = new FormData();

        formData.append('file', blob, 'userprofile');
        formData.append('reff_id', this.user_id);                

        this.loading = true;
        model.uploadImage(formData).then(res=>{
          this.init();            
        });
    },             

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },

    copyCode () {
      let testingCodeToCopy = document.querySelector('#testing-code')
      testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        window.getApp.$emit('showSnackbar', {
            show : true,
            text : 'The code was copied ' + msg,
            color: 'cyan'
        });        
      } catch (err) {
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  }
};
</script>
<style>
  #profile-scroll{
      height: calc(100vh - 96px);
      overflow-y:auto; 
  }
  .vue-image-crop-upload .vicp-wrap{      
      height: 65%;
      width : 80%;
      min-height:330px;
      max-width: 600px;
  }
</style>